import { Component, OnInit, Input } from '@angular/core';
import { ContactAdresse } from 'src/app/shared/models/iContact/contact/contact-adresse';
import { ContactsLienMembres, LinkedMembersInfos } from 'src/app/shared/models/iContact/global/contacts-lien-membres';
import { ToastrService } from 'ngx-toastr';
import { ContactPreviewModalComponent } from '../contact-preview-modal/contact-preview-modal.component';
import { ConfirmationService } from 'primeng/api';
import * as moment from 'moment';
import { DataService } from 'src/app/shared/services/data.service';
import { DialogService } from 'primeng/dynamicdialog';
import { LinkedMember } from 'src/app/shared/interfaces';
import { Cols } from 'src/app/shared/models/cols';
import { ActivatedRoute, Router } from '@angular/router';

import * as _ from 'underscore';
import { ContactsGlobalService } from 'src/app/shared/services/contacts-global.service';
import { ContactsService } from 'src/app/shared/services/contacts.service';
import { LanguagesService } from 'src/app/shared/services/languages.service';
import { Contact } from 'src/app/shared/models/iContact/contact/contact';
import { environment } from 'src/environments/environment';
import { IButton, TranslateService } from '@devinforius/i-essentials';

@Component({
  selector: 'app-contact-details',
  templateUrl: './contact-details.component.html',
  styleUrls: ['./contact-details.component.scss'],
})
export class ContactDetailsComponent implements OnInit {
  @Input() public contactId: number; // if it's preview modal mode
  @Input() public from: string; // if it's preview modal mode

  @Input() set displayedInModal(value: boolean) {
    if (value) {
      this.displayedInModalBoolean = value;
    } else {
      this.displayedInModalBoolean = false;
    }
  }
  public displayedInModalBoolean = false;
  public liens: ContactsLienMembres[] = [];
  public liensSocMembres: LinkedMember[] = [];
  public liensSocSoc: LinkedMembersInfos[] = [];
  public contactName: string;

  public colSociety: Cols[] = [
    {
      field: 'name',
      header: 'Nom',
      format: (value: string): string => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'adresse',
      header: 'Adresse',
      format: (value: string): string => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'codePostal',
      header: 'Code postal',
      format: (value: string): string => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'localite',
      header: 'Localité',
      format: (value: string): string => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'fax',
      header: 'Fax',
      format: (value: string): string => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'gsm',
      header: 'GSM',
      format: (value: string): string => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'mail',
      header: 'Email',
      format: (value: string): string => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'site',
      header: 'Site',
      format: (value: string): string => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'telephone',
      header: 'Téléphone',
      format: (value: string): string => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'titre',
      header: 'Titre',
      format: (value: string): string => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'preview',
      header: 'Aperçu',
      sortable: false,
      width: '5px',
      format: (): string => {
        return `<i class="bi bi-eye-fill"></i>`;
      },
      export: (): string => {
        return '';
      },
      click: (column) => {
        this.openPreviewModal(column);
      },
    },
  ];

  public contact: Contact;
  public principalAdress: ContactAdresse;
  public fullMode = false;
  public displayMembersLinks = false;
  public displaySocietyLinks = false;
  public $moment = moment;

  public titleButtons: IButton[] = [
    {
      text: 'homeCourrier.buttons.edit',
      styleClass: 'green',
      id: 'btnEditContact',
      click: (): void => this.goToEdition(),
    },
    {
      text: 'homeCourrier.buttons.delete',
      styleClass: 'red',
      id: 'btnDeleteContact',
      click: (): void => this.deleteContact(),
    },
  ];

  constructor(
    private route: ActivatedRoute,
    private contactsService: ContactsService,
    private toastr: ToastrService,
    private router: Router,
    private confirmService: ConfirmationService,
    private dataService: DataService,
    private dialogService: DialogService,
    private contactsGlobalService: ContactsGlobalService,
    private languagesService: LanguagesService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.getTranslations();
    if (this.contactId) {
      this.getContact(this.contactId);
    } else {
      this.route.params.subscribe({
        next: (params) => {
          const id = +params.id;
          this.getContact(id);
        },
      });
    }
  }

  private getTranslations(): void {
    this.titleButtons = this.titleButtons.map((button) => {
      return {
        ...button,
        text: this.translate.translate(button.text),
      };
    });
  }

  getContact(id: number): void {
    this.contactsService.fetchContact(id, 'iCourrier').subscribe({
      next: (response) => {
        this.contact = new Contact(response);
        this.contactName = (this.contact.prenom ? this.contact.prenom : '') + ' ' + (this.contact.nom ? this.contact.nom : '');
        this.getLanguages();
        this.getLinksContacts();
      },
      error: (error) => {
        console.error('Error : ', error);
      },
    });
  }

  public getTitle(): string {
    const name = this.contact.nom ? this.contact.nom : '';
    if (this.contact.typeSociete) {
      return name;
    } else {
      const firstName = this.contact.prenom ? this.contact.prenom : '';
      const contactFunction = this.contact.fonction ? this.contact.fonction : '';
      let text = name + ' ' + firstName + ' ' + contactFunction;
      if (this.contact?.listSocieteLies?.length) {
        text += ' pour ' + this.contact.listSocieteLies.map((item) => item.nom).join(', ');
      }
      return text;
    }
  }

  private getLanguages(): void {
    this.languagesService.fetchLanguages().subscribe({
      next: (res) => {
        this.contact.langue = res.find((item) => item.id === this.contact.langueId);
      },
    });
  }

  // $$$$$$$$$$ UPDATE $$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
  public getLinksContacts(): void {
    this.liens = [];
    this.liensSocMembres = [];
    this.contactsGlobalService.getSocietesV2(this.contact.id).subscribe({
      next: (res) => {
        if (res.typeSociete === false) {
          // C'est les sociétés liés
          this.liensSocSoc = res.liensMembres.map((item) => new LinkedMembersInfos(item));
        } else {
          res.liensMembres.map((item) => {
            this.liensSocMembres.push({
              name: (item.lienContact.nom ? item.lienContact.nom + ' ' : '') + (item.lienContact.prenom ? item.lienContact.prenom : ''),
              id: item.lienContact.id,
              adresse: item.lienInfo.adresse,
              codePostal: item.lienInfo.codePostal,
              fax: item.lienInfo.fax,
              gsm: item.lienInfo.gsm,
              localite: item.lienInfo.localite,
              mail: item.lienInfo.mail,
              relationId: item.lienInfo.relationId,
              site: item.lienInfo.site,
              telephone: item.lienInfo.telephone,
              titre: item.lienInfo.titre,
            });
          });
        }
      },
    });
  }

  deleteContact(): void {
    this.confirmService.confirm({
      message: 'Voulez-vous vraiment supprimer ce contact?',
      accept: () => {
        this.contactsService.deleteContact('iCourrier', this.contact.id).subscribe({
          next: () => {
            this.toastr.success('Merci', "Ce contact n'apparaîtra plus dans votre liste de contact");
            this.dataService.setReloadContact(true);
            this.ngOnInit();
            this.router.navigateByUrl('/private/ic/contacts');
          },
          error: (error) => {
            console.error('Error : ', error);
          },
        });
      },
    });
  }

  goToEdition(): void {
    if (this.from === 'userRight') {
      const url = '/private/ic/contacts/';
      const config = environment;
      window.open(config.baseUrl + url + this.contact.id);
    } else {
      this.router.navigateByUrl('/private/ic/contacts/' + this.contact.id);
    }
  }

  openPreviewModal(data: LinkedMember): void {
    this.dialogService.open(ContactPreviewModalComponent, {
      dismissableMask: false,
      header: ' Aperçu du contact ' + data?.name,
      baseZIndex: 1000,
      width: '60vw',
      data: {
        data: data,
      },
    });
  }

  openAdvancedSearch(type: 'Sender' | 'Recipient'): void {
    sessionStorage.setItem('advancedSearch', 'oui');
    const data: {
      IsAdvancedSearch: boolean;
      ExportNatureCustomDatas: boolean;
      category: string;
      Type: string;
      ExpediteurIds?: number[];
      DestinataireIds?: number[];
    } = {
      IsAdvancedSearch: true,
      ExportNatureCustomDatas: false,
      category: '',
      Type: '',
      ExpediteurIds: null,
      DestinataireIds: null,
    };
    switch (type) {
      case 'Sender':
        data.Type = 'Entrant';
        data.category = 'Entrant';
        data.ExpediteurIds = [this.contact.id];
        delete data.DestinataireIds;
        break;
      case 'Recipient':
        data.Type = 'Sortant';
        data.category = 'Sortant';
        data.DestinataireIds = [this.contact.id];
        delete data.ExpediteurIds;
        break;
    }
    sessionStorage.setItem('searchData', JSON.stringify(data));

    const queryParams = Object.keys(data)
      .map((key) => {
        if (_.isArray(data[key])) {
          return `${key}=${data[key].toString()}`;
        } else {
          return `${key}=${data[key]}`;
        }
      })
      .join('&');

    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/private/ic/courriers/advancedSearch'], {
        queryParams: {
          advancedSearchData: queryParams,
        },
      })
    );
    window.open(url, '_blank');
  }
}
